var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-tel-input',{staticClass:"form-input",style:(_vm.inputStyle),attrs:{"value":_vm.input,"defaultCountry":_vm.item.countryPrefix,"placeholder":_vm.$t('form.phone-placeholder'),"required":_vm.item.required == 1,"validCharactersOnly":""},on:{"input":(text, object) => _vm.phoneChanged(object)}})
}
var staticRenderFns = []

export { render, staticRenderFns }